import { Injectable } from '@angular/core';
import {HttpCustomerService} from './httpcustomer.service';
import {WebResponesContext} from 'src/model/common';
import { MessageclientService } from "src/service/messageclient.service";
declare var app;
declare var wx;
declare var sha1;
@Injectable({
  providedIn: 'root'
})
export class WxjssdkService {

  constructor(
    public http:HttpCustomerService,
    public msg:MessageclientService
  ) { 
  }
/**
 * 获取微信相机相册功能
 * @param url 获取当前页面的url不包括“#”
 */
public GetWXJSSDK(url:any):Promise<any>{
 const that = this;
    //const url = location.href.split('#')[0];
    let body={
      ConfigName: "WeChatPublicNumber"
    };
    let requestBody={Type: "0"};
        requestBody["Url"]=url;
    body["RequestBody"] = requestBody;
    return new Promise<any>((resolve,reject)=>{
      that.http.post(app.WXJSSDKURL,body).then(WXdata=>{
        if(WXdata.ResponseMessage.Success){
        let config={
              debug: true,
              appId:WXdata.Status["Appid"],
              timestamp:WXdata.Status["Timestamp"] , 
              nonceStr: WXdata.Status["Noncestr"], 
              signature: WXdata.Status["Signature"],
              jsApiList: ['chooseImage']// 必填，需要使用的JS接口列表
              };
              wx.config(config);
              wx.ready(function(){
                 wx.chooseImage({
                  count: 1, // 默认9
                  sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
                  sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
                  isSaveToAlbum: 0, //  //整型值，0表示拍照时不保存到系统相册，1表示自动保存，默认值是1
                  success: function (res) {
                    let _obj={};
                        _obj["localIds"] = res.localIds;
                        WXdata.Status = _obj;
                        resolve(WXdata);
                  //var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                  }
                });
              });
              wx.error(function(error){
                reject(error);
              });
        }
      }).catch(error=>{
        reject(error);
      });
    });
}

public Getsignature():any{
//  let jsapi_ticket = localStorage.getItem("wxsdk");
 let timestamp = new Date().getTime();//时间戳
 let noncestr = Math.random().toString(36).substring(2);//随机数
 //let url = location.href.split('#')[0];
 let url = location.href;
 console.log(url);
 let string1 ="jsapi_ticket=3912d27af380f494bcd42f65624851ba9f8152a0";
      string1+="&noncestr=";
      string1+="&timestamp=1549012057";
      string1+="&url=http://192.168.0.87:8100/#/tabs/about";
      console.log(string1);
      let signature = sha1(string1);
      console.log(signature);
      wx.config({
        debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: 'wx82cb54f486f60b4a', // 必填，公众号的唯一标识
        timestamp: '1549012164', // 必填，生成签名的时间戳
        nonceStr: 'u59GohkiHcGx8TzM', // 必填，生成签名的随机串
        signature: '1c98bbe2fc4d0bb14311c0489c03c2eb4e0fe0e6',// 必填，签名
        jsApiList: ['chooseImage','previewImage'] // 必填，需要使用的JS接口列表
    });
return sha1(string1);
}
/**
 * 微信拍照
 * @param sourceType  可以指定来源是相册(album)还是相机(camera)，默认二者都有,default:['album','camera'];
 * @param sizeType 可以指定是原图(original)还是压缩图(compressed)，默认二者都有.default:['compressed'];
 * @param count 默认1，需要上传的图片个数,默认1
 */
public GetWxCamera(sourceType:Array<string>=['album','camera'],sizeType:Array<string>=['compressed'],count:number=1):Promise<WebResponesContext>{
  const that =this;
  return new Promise<WebResponesContext>((resolve,reject)=>{
    let msg:WebResponesContext=new WebResponesContext();
    msg.ResponseMessage.Success=true;
    console.log("拍照开始");
    that.http.IsWeChatConfig().then(res=>{
      wx.chooseImage({
        count: count, // 默认9
        sizeType: sizeType, // 可以指定是原图还是压缩图，默认二者都有
        sourceType: sourceType, // 可以指定来源是相册还是相机，默认二者都有
        isSaveToAlbum: 0, //  //整型值，0表示拍照时不保存到系统相册，1表示自动保存，默认值是1
        success: function (res) {
          console.log(res,"拍照成功");
          sessionStorage.setItem("1001",res+"拍照成功");
          let localIds:any =res.localIds[0].toString();
          wx.uploadImage({
            localId: localIds, // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function (res) {
                let serverId = res.serverId; // 返回图片的服务器端ID
                let _url:any =app.WXJSUPLOADURL+serverId;
                that.http.post(_url,{}).then(body=>{
                  console.log(body,"上传成功");
                  if(body.ResponseMessage.Success){
                    resolve(body);
                  }else{
                    msg.ResponseMessage.Success=false;
                    msg.ResponseMessage.ErrorCode=body.ResponseMessage.ErrorCode;
                    msg.ResponseMessage.ErrorMessage=body.ResponseMessage.ErrorMessage;
                    reject(msg);
                  }
                }).catch(err=>{
                          console.log(err,"查看图失败");
                          msg.ResponseMessage.Success=false;
                          msg.ResponseMessage.ErrorMessage=err;
                          reject(msg);
                });
                console.log(serverId,"上传的serverID");
            }
          });
          // wx.getLocalImgData({
          //       localId: localIds, // 图片的localID
          //       success: function (res) {
          //         var url:any = res.localData.toString(); // localData是图片的base64数据，可以用img标签显示
          //         console.log(url,"是否android");
          //         if(url.substr(0,5)!='data:'){
          //           url='data:image/ipg;base64,'+url;
          //         }
          //         alert(url);
          //         // alert(url);
          //         // console.log(url,"地址栏");
          //         that.native.AsyncCompressAccurately(url,1,300,2).then(files=>{
          //            console.log(files,"上传图片成功");
          //            resolve(files);
          //         }).catch(err=>{
          //           msg.ResponseMessage.Success=false;
          //           msg.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
          //           msg.Status=url;
          //           reject(msg);
          //         });
          //       },fail:function(err){
          //         console.log(err,"查看图失败");
          //         msg.ResponseMessage.Success=false;
          //         msg.ResponseMessage.ErrorMessage=err;
          //         reject(msg);
          //       }
          //     });
         
        },fail:function(err){
          console.log(err,"拍照失败");
          sessionStorage.setItem("1002",err+"拍照失败");
          msg.ResponseMessage.Success=false;
          msg.ResponseMessage.ErrorMessage=err;
          reject(msg);
        }
    });
    }).catch(err=>{
      console.log(err,"拍照异常");
      sessionStorage.setItem("1003",err+"拍照异常");
      msg.ResponseMessage.Success=false;
      msg.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
      reject(msg);
    });

  });
}
/**
 * 预览图片接口
 * @param current 当前显示图片的http链接
 * @param urls 需要预览的图片http链接列表
 */
public GetWxPreviewImage(current:string,urls:Array<string>):Promise<WebResponesContext>{
  return new Promise<WebResponesContext>((resolve,reject)=>{
    let msg:WebResponesContext=new WebResponesContext();
        msg.ResponseMessage.Success=true;
        wx.previewImage({
          current: current, // 当前显示图片的http链接
          urls: urls, // 需要预览的图片http链接列表
          success:function(res){
            msg.Status=res;
            resolve(msg);
          },fail:function(res){
            msg.ResponseMessage.Success=false;
            msg.ResponseMessage.ErrorMessage=res;
            reject(msg);
          }
        });
      });
}
/**
 * 下载图片接口
 * @param serverId 需要下载的图片的服务器端ID，由uploadImage接口获得
 * @param isShowProgressTips 默认为1，显示进度提示
 */
public GetWxdownloadImage(serverId:string,isShowProgressTips:number=1):Promise<WebResponesContext>{
  return new Promise<WebResponesContext>((resolve,reject)=>{
    let msg:WebResponesContext=new WebResponesContext();
        msg.ResponseMessage.Success=true;
        wx.downloadImage({
          serverId: serverId, // 需要下载的图片的服务器端ID，由uploadImage接口获得
          isShowProgressTips: isShowProgressTips, // 默认为1，显示进度提示
          success:function(res){
            msg.Status=res;
            resolve(msg);
          },fail:function(res){
            msg.ResponseMessage.Success=false;
            msg.ResponseMessage.ErrorMessage=res;
            reject(msg);
          }
        });
      });
}
/**
 * 获取微信定位信息
 * @param type 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
 */
public GetWxLocation(type:string="wgs84"):Promise<WebResponesContext>{
  const that=this;
  return new Promise<WebResponesContext>((resolve,reject)=>{
    let msg:WebResponesContext=new WebResponesContext();
        msg.ResponseMessage.Success=true;
        console.log("微信定位");
        that.http.IsWeChatConfig().then(res=>{
          wx.getLocation({
            type: type, // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function (res) {
                // var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                // var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                // var speed = res.speed; // 速度，以米/每秒计
                // var accuracy = res.accuracy; // 位置精度
                msg.Status=res;
                resolve(msg);
            },fail:function(res){
              msg.ResponseMessage.Success=false;
              msg.ResponseMessage.ErrorMessage=res;
              reject(msg);
            }
            });
        }).catch(err=>{
          msg.ResponseMessage.Success=false;
          msg.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
          reject(msg);
        });
     
      });
    }
    /**
     * 扫描二维码
     * @param needResult 默认为1，0扫描结果由微信处理，1则直接返回扫描结果，
     * @param scanType 可以指定扫二维码还是一维码，默认二者都有
     */
    public GetWxScanQRCode(needResult:number=1,scanType:Array<string>=["qrCode","barCode"]):Promise<WebResponesContext>{
      const that=this;
      return new Promise<WebResponesContext>((resolve,reject)=>{
        console.log("扫描二维码");
        let msg:WebResponesContext=new WebResponesContext();
            msg.ResponseMessage.Success=true;
            that.http.IsWeChatConfig().then(res=>{
              wx.scanQRCode({
                needResult: needResult, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: scanType, // 可以指定扫二维码还是一维码，默认二者都有
                success: function (res) {
                  // alert("扫码销量");
                  console.log(res,"扫码销量");
                  if(res.resultStr){
                    // let result = JSON.parse(res.resultStr); // 当needResult 为 1 时，扫码返回的结果
                    let result = res.resultStr;
                    msg.Status=result;
                    resolve(msg);
                  }else{
                    msg.ResponseMessage.Success=false;
                    msg.ResponseMessage.ErrorMessage=res;
                    reject(msg);
                  }
              },fail:function(res){
                msg.ResponseMessage.Success=false;
                msg.ResponseMessage.ErrorMessage=res;
                reject(msg);
              }
              });
            }).catch(err=>{
              msg.ResponseMessage.Success=false;
              msg.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
              reject(msg);
            });
          
          });
        }
        /**
         * 获取“分享给朋友”按钮点击状态及自定义分享内容接口
         * @param pt 
         * {
         *  title: '', // 分享标题
         * desc: '', // 分享描述
         * link: '', // 分享链接
         * imgUrl: '', // 分享图标
         * type: '', // 分享类型,music、video或link，不填默认为link
         * dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
         * }
         */
public GetMenuShareAppMessage(pt:any={}):Promise<WebResponesContext>{
  const that=this;
  return new Promise<WebResponesContext>((resolve,reject)=>{
    console.log("分享到好友");
        let msg:WebResponesContext=new WebResponesContext();
               msg.ResponseMessage.Success=true;
              let option:any={
                title: pt.title, // 分享标题
                desc: pt.desc, // 分享描述
                link: pt.link, // 分享链接
                imgUrl: pt.imgUrl, // 分享图标
                // type: '', // 分享类型,music、video或link，不填默认为link
                // dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success: function (res) { 
                  msg.Status=res;
                    // 用户确认分享后执行的回调函数
                    resolve(msg);
                },
                cancel: function (err) { 
                    // 用户取消分享后执行的回调函数
                    msg.ResponseMessage.ErrorMessage=err;
                    msg.ResponseMessage.Success=false;
                    reject(msg);
                }
               };
            that.http.IsWeChatConfig().then(res=>{
              let _temoOption:any=Object.assign(option,pt);
              wx.onMenuShareAppMessage(_temoOption);
            }).catch(err=>{
              msg.ResponseMessage.Success=false;
              msg.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
              reject(msg);
            });
  });
 }
  /**
  * 自定义转发到会话
  * @param config 需要配置的参数列表 默认
  *  {
   *             title: '', // 分享标题
    *            desc: '', // 分享描述
    *           link: '', // 分享链接
    *          imgUrl: '' // 分享封面
    * }
  * 
  * 
  * 
  * 
  */
 public GetshareAppMessage(config:any={title:'',desc:'',link:'',imgUrl:''}):Promise<WebResponesContext>{
   const that=this;
   return new Promise<WebResponesContext>((resolve,reject)=>{
    let msg:WebResponesContext=new WebResponesContext();
        msg.ResponseMessage.Success=true;
        that.http.IsWeChatConfig().then(res=>{
          wx.invoke(
            "shareAppMessage", {
                    title: config.title, // 分享标题
                    desc: config.desc, // 分享描述
                    link: config.link, // 分享链接
                    imgUrl: config.imgUrl // 分享封面
              }, function(res) {
                  if (res.err_msg == "shareAppMessage:ok") {
                    msg.Status=res;
                    resolve(msg);
                  }else{
                    msg.ResponseMessage.Success=false;
                    msg.ResponseMessage.ErrorMessage=res;
                    reject(msg);
                  }
              },function(res){
                msg.ResponseMessage.Success=false;
                msg.ResponseMessage.ErrorMessage=res;
                reject(msg);
              });
        }).catch(err=>{
          msg.ResponseMessage.Success=false;
          msg.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
          reject(msg);
         });
     
      });
 }
 /**
  * 自定义转发到微信
  * @param config 需要配置的参数列表 默认
  *  {
   *             title: '', // 分享标题
    *            desc: '', // 分享描述
    *           link: '', // 分享链接
    *          imgUrl: '' // 分享封面
    * }
  * 
  * 
  * 
  * 
  */
 public GetshareWechatMessage(config:any={title:'',desc:'',link:'',imgUrl:''}):Promise<WebResponesContext>{
  const that=this;
  return new Promise<WebResponesContext>((resolve,reject)=>{
   let msg:WebResponesContext=new WebResponesContext();
       msg.ResponseMessage.Success=true;
       that.http.IsWeChatConfig().then(res=>{
        wx.invoke(
          "shareWechatMessage", {
                  title: config.title, // 分享标题
                  desc: config.desc, // 分享描述
                  link: config.link, // 分享链接
                  imgUrl: config.imgUrl // 分享封面
              }, function(res) {
                  if (res.err_msg == "shareWechatMessage:ok") {
                    msg.Status=res;
                    resolve(msg);
                  }else{
                    msg.ResponseMessage.Success=false;
                    msg.ResponseMessage.ErrorMessage=res;
                    reject(msg);
                  }
              },function(res){
                msg.ResponseMessage.Success=false;
                msg.ResponseMessage.ErrorMessage=res;
                reject(msg);
              }
          );
       }).catch(err=>{
        msg.ResponseMessage.Success=false;
        msg.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
        reject(msg);
       });
     });
}
/**
 * 转发到朋友圈（即将废弃）
 * @param config 
 */
public onMenuShareTimeline(config:any={title:'',link:'',imgUrl:''}):Promise<WebResponesContext>{
  const that=this;
  return new Promise<WebResponesContext>((resolve,reject)=>{
   let msg:WebResponesContext=new WebResponesContext();
       msg.ResponseMessage.Success=true;
       that.http.IsWeChatConfig(true).then(res=>{
        wx.onMenuShareTimeline({
          title: config.title, // 分享标题
          link: config.link, // 分享链接；在微信上分享时，该链接的域名必须与企业某个应用的可信域名一致
          imgUrl: config.imgUrl, // 分享图标
          success: function (res) {
              // 用户确认分享后执行的回调函数
              resolve(res);
          },
          cancel: function (err) {
              // 用户取消分享后执行的回调函数
              reject(err);
          }
        });
       }).catch(err=>{
        msg.ResponseMessage.Success=false;
        msg.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
        reject(msg);
       });
     });
}
/**
 * 转发到朋友圈
 * @param config 
 */
public updateTimelineShareData(config:any={title:'',link:'',imgUrl:''}):Promise<WebResponesContext>{
  const that=this;
  return new Promise<WebResponesContext>((resolve,reject)=>{
   let msg:WebResponesContext=new WebResponesContext();
       msg.ResponseMessage.Success=true;
       that.http.IsWeChatConfig(true).then(res=>{
        wx.updateTimelineShareData({
          title: config.title, // 分享标题
          link: config.link, // 分享链接；在微信上分享时，该链接的域名必须与企业某个应用的可信域名一致
          imgUrl: config.imgUrl, // 分享图标
          success: function (res) {
              // 用户确认分享后执行的回调函数
              resolve(res);
          },
          cancel: function (err) {
              // 用户取消分享后执行的回调函数
              reject(err);
          }
        });
       }).catch(err=>{
        msg.ResponseMessage.Success=false;
        msg.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
        reject(msg);
       });
     });
}
/**
  * 预览文件接口
  * @param config 需要配置的参数列表 默认
  *  {
   *             url: '', // 需要预览文件的地址(必填，可以使用相对路径)
    *            name: '', // 需要预览文件的文件名(不填的话取url的最后部分)
    *           size: 1048576 , // 需要预览文件的字节大小(必填)
    * }
  * 
  * 
  * 
  * 
  */
 public GetpreviewFile(config:any={url:'',name:'',size:1048576}):Promise<WebResponesContext>{
  const that=this;
  return new Promise<WebResponesContext>((resolve,reject)=>{
   let msg:WebResponesContext=new WebResponesContext();
       msg.ResponseMessage.Success=true;
       that.http.IsWeChatConfig().then(res=>{
         try{
          wx.previewFile({
            url: config.url, // 需要预览文件的地址(必填，可以使用相对路径)
            name: config.name, // 需要预览文件的文件名(不填的话取url的最后部分)
            size: config.size, // 需要预览文件的字节大小(必填)
            success: function (res) {
              // 用户确认分享后执行的回调函数
              resolve(res);
           },
            cancel: function (err) {
                // 用户取消分享后执行的回调函数
                reject(err);
            }
            });
         }catch(err){
          msg.ResponseMessage.Success=false;
          msg.ResponseMessage.ErrorMessage=err;
          reject(msg);
         }
       }).catch(err=>{
        msg.ResponseMessage.Success=false;
        msg.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
        reject(msg);
       });
     
     });
}
/**
 * 获取当前外部联系人userid
 * 从外部联系人的profile、外部聊天附件栏、外部聊天侧边栏进入页面时才可成功调用该接口，接口地址：https://work.weixin.qq.com/api/doc/90000/90136/91799
 */
public getCurExternalContact():Promise<WebResponesContext>{
  const that =this;
  return new Promise<WebResponesContext>((resolve,reject)=>{
    let msg:WebResponesContext=new WebResponesContext();
        msg.ResponseMessage.Success=true;
        that.http.IsWeChatConfig(true).then(res=>{
            wx.invoke("getCurExternalContact", {
            }, function(res){
            if(res.err_msg == "getCurExternalContact:ok"){
                // userId  = res.userId ; //返回当前外部联系人userId
                msg.Status=res.userId;
                resolve(msg);
            }else {
                //错误处理
                msg.ResponseMessage.Success=false;
                msg.ResponseMessage.ErrorMessage=res.err_msg;
                reject(msg);
            }
          });
        }).catch(err=>{
          msg.ResponseMessage.Success=false;
          msg.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
          reject(msg);
         });
      });
   }

/**
 *  打开外部个人信息页接口
 * 调用此接口将唤起成员或外部联系人的个人信息页面，接口地址：https://work.weixin.qq.com/api/doc/90000/90136/91799
 * @param type 1表示该userid是企业成员，2表示该userid是外部联系人,默认为1;
 * @param userid 可以是企业成员，也可以是外部联系人
 */
public OpenUserProfile(type:number=1,userid:string=""):Promise<WebResponesContext>{
  const that =this;
  return new Promise<WebResponesContext>((resolve,reject)=>{
    let msg:WebResponesContext=new WebResponesContext();
        msg.ResponseMessage.Success=true;
        that.http.IsWeChatConfig().then(res=>{
          wx.invoke('openUserProfile', {
            "type": type, //1表示该userid是企业成员，2表示该userid是外部联系人
            "userid": userid //可以是企业成员，也可以是外部联系人
              }, function(res){
                let errorMsg:any =res.err_msg;
              if(res.err_msg != "openUserProfile:ok"){
                //错误处理
                msg.ResponseMessage.Success=false;
                if(res.err_msg.indexOf("unexpect err")!=-1){
                  errorMsg="此联系人不存在";
                }
                msg.ResponseMessage.ErrorMessage=errorMsg;
                reject(msg);
              }else{
                msg.Status=res.err_msg;
                resolve(msg);
              }
              });
        }).catch(err=>{
          msg.ResponseMessage.Success=false;
          msg.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
          reject(msg);
         });
      });
   }
   /**
    * 外部联系人选人接口,返回选中人的userID
    * 调用此接口将唤起该成员里所有的外部联系人列表，获取员工选择的外部联系人的userid
    * @param filterType //0表示展示全部外部联系人列表，1表示仅展示未曾选择过的外部联系人。默认值为0；除了0与1，其他值非法。在企业微信2.4.22及以后版本支持该参数
    */
   public selectExternalContact(filterType:number=1):Promise<WebResponesContext>{
    const that =this;
    return new Promise<WebResponesContext>((resolve,reject)=>{
      let msg:WebResponesContext=new WebResponesContext();
          msg.ResponseMessage.Success=true;
          that.http.IsWeChatConfig(true).then(res=>{
            wx.invoke('selectExternalContact', {
              "filterType": filterType, //0表示展示全部外部联系人列表，1表示仅展示未曾选择过的外部联系人。默认值为0；除了0与1，其他值非法。在企业微信2.4.22及以后版本支持该参数
            }, function(res){
            if(res.err_msg == "selectExternalContact:ok"){
              // userIds  = res.userIds ; //返回此次选择的外部联系人userId列表，数组类型
              console.log(JSON.stringify(res),"选择外部联系人");
              msg.Status=res.userIds;
              resolve(msg);
            }else {
              //错误处理
              console.log(JSON.stringify(res),"选择外部联系人错误");

              msg.ResponseMessage.Success=false;
              msg.ResponseMessage.ErrorMessage=res.err_msg;
              reject(msg);
            }
            });
          }).catch(err=>{
            msg.ResponseMessage.Success=false;
            msg.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
            reject(msg);
           });
        });
     }
/**
 * 打开个人信息页接口(通讯录)
 * @param filterType 1表示该userid是企业成员，2表示该userid是外部联系人
 * @param userid 可以是企业成员，也可以是外部联系人
 */
   public OpenOwnUserProfile(type:number=1,userid:string=''):Promise<WebResponesContext>{
    const that =this;
    return new Promise<WebResponesContext>((resolve,reject)=>{
      let msg:WebResponesContext=new WebResponesContext();
          msg.ResponseMessage.Success=true;
          that.http.IsWeChatConfig(true).then(res=>{
            wx.invoke('openUserProfile', {
              "type": type, //0表示展示全部外部联系人列表，1表示仅展示未曾选择过的外部联系人。默认值为0；除了0与1，其他值非法。在企业微信2.4.22及以后版本支持该参数
              "userid":userid
            }, function(res){
            if(res.err_msg == "openUserProfile:ok"){
              // userIds  = res.userIds ; //返回此次选择的外部联系人userId列表，数组类型
              msg.Status=res.err_msg;
              resolve(msg);
            }else {
              //错误处理
              msg.ResponseMessage.Success=false;
              msg.ResponseMessage.ErrorMessage=res.err_msg;
              reject(msg);
            }
            });
          }).catch(err=>{
            msg.ResponseMessage.Success=false;
            msg.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
            reject(msg);
           });
        });
     }
     /**
      * 选人接口（通讯录）
      * @param fromDepartmentId 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
      * @param mode 必填，选择模式，single表示单选，multi表示多选
      * @param type 必填，选择限制类型，指定department、user中的一个或者多个
      * @param selectedDepartmentIds 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
      * @param selectedUserIds 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
      */
     public SelectOwnEnterpriseContact(fromDepartmentId:number=-1,mode:string="multi",type:Array<string> = ["department", "user"],selectedDepartmentIds:Array<string>=[],selectedUserIds:Array<string>=[]):Promise<WebResponesContext>{
      const that =this;
      return new Promise<WebResponesContext>((resolve,reject)=>{
        let msg:WebResponesContext=new WebResponesContext();
            msg.ResponseMessage.Success=true;
            that.http.IsWeChatConfig().then(res=>{
              wx.invoke("selectEnterpriseContact", {
                "fromDepartmentId": fromDepartmentId,// 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
                "mode": mode,// 必填，选择模式，single表示单选，multi表示多选
                "type": type,// 必填，选择限制类型，指定department、user中的一个或者多个
                "selectedDepartmentIds": selectedDepartmentIds,// 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
                "selectedUserIds": selectedUserIds// 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
                    },function(res){
                            if (res.err_msg == "selectEnterpriseContact:ok")
                            {
                              msg.Status=res;
                              resolve(msg);
                            }else{
                               msg.ResponseMessage.Success=false;
                               msg.ResponseMessage.ErrorMessage=res.err_msg;
                              //  reject(msg);
                            }
                    },function(res){
                       if(res.errMsg=="selectEnterpriseContact:无法与非外部联系人发起聊天"){
                            res.errMsg="对方还不是您的好友,请先添加对方为好友";
                            msg.ResponseMessage.ErrorCode=404;
                        }
                      msg.ResponseMessage.Success=false;
                      msg.ResponseMessage.ErrorMessage=res.err_msg;
                      reject(msg);
                    }
               );
            }).catch(err=>{
              msg.ResponseMessage.Success=false;
              msg.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
              reject(msg);
             });
          });
       }
       /**
        * 创建会话接口 参考api地址:https://work.weixin.qq.com/api/doc/90000/90136/90511
        ***** 注意：userIds和externalUserIds至少选填一个，且userIds+externalUserIds总数不能超过2000。
        * @param userIds 参与会话的企业成员列表，格式为userid1;userid2;...，用分号隔开。默认为空
        * @param externalUserIds 参与会话的外部联系人(微信联系人)列表，格式为userId1;userId2;…，用分号隔开。默认为空。
        * @param groupName 必填，会话名称。单聊时该参数传入空字符串""即可。默认为空。
        */
       public CreateopenEnterpriseChat(userIds:string='',externalUserIds:string='',groupName:string):Promise<WebResponesContext>{
        const that =this;
        return new Promise<WebResponesContext>((resolve,reject)=>{
          let msg:WebResponesContext=new WebResponesContext();
              msg.ResponseMessage.Success=true;
              msg.ResponseMessage.ErrorCode=0;
              console.log("微信错误");
              that.http.IsWeChatConfig().then(res=>{
                wx.openEnterpriseChat({
                  // 注意：userIds和externalUserIds至少选填一个，且userIds+externalUserIds总数不能超过2000。
                  userIds: userIds,    //参与会话的企业成员列表，格式为userid1;userid2;...，用分号隔开。
                  externalUserIds: externalUserIds, // 参与会话的外部联系人列表，格式为userId1;userId2;…，用分号隔开。
                  groupName: groupName,  // 必填，会话名称。单聊时该参数传入空字符串""即可。
                    success: function(res) 
                    {
                        // 回调
                        console.log("微信成功回调");
                        msg.Status=res;
                        resolve(msg);
                    },
                    fail: function(res) {
                      console.log(res.errMsg,"微信错误回调");
                        if(res.errMsg.indexOf('function not exist') > -1){
                          res.errMsg="版本过低请升级";
                          msg.ResponseMessage.ErrorCode=404;
                        }
                        if(res.errMsg=="openEnterpriseChat:无法与非外部联系人发起聊天"){
                            res.errMsg="对方还不是您的好友,请先添加对方为好友";
                            msg.ResponseMessage.ErrorCode=404;
                        }
                        if(res.errMsg=="openEnterpriseChat:invalid ids"){
                          res.errMsg="对方还不是您的好友,请先添加对方为好友";
                          msg.ResponseMessage.ErrorCode=404;
                         
                        }
                        msg.ResponseMessage.Success=false;
                        msg.ResponseMessage.ErrorMessage=res.errMsg;
                        reject(msg);
                    }
                });
              }).catch(err=>{
                console.log("微信异常回调");
                msg.ResponseMessage.Success=false;
                msg.ResponseMessage.ErrorMessage=err.ResponseMessage.ErrorMessage;
                reject(msg);
               });
            });
         }
         /**
          * 设置系统剪贴板的内容
          * @param content 剪贴板的内容
          */
         public SetClipboardData(content:string):Promise<WebResponesContext>{
          const that =this;
          return new Promise<WebResponesContext>((resolve,reject)=>{
            let msg:WebResponesContext=new WebResponesContext();
                msg.ResponseMessage.Success=true;
                msg.ResponseMessage.ErrorCode=0;
                  wx.setClipboardData({
                    data: content,    // 设置的内容
                    success: function(res) {
                      msg.ResponseMessage.Success=true;
                      msg.ResponseMessage.ErrorMessage=res.errMsg;
                      resolve(msg);
                    },fail:function(res){
                      msg.ResponseMessage.Success=false;
                      msg.ResponseMessage.ErrorMessage=res.errMsg;
                      reject(msg);
                    }
                  })
              });
           }
           /**
            * 跳转加好友
            */
            public navigateToAddCustomer():Promise<WebResponesContext>{
              const that =this;
              return new Promise<WebResponesContext>((resolve,reject)=>{
                let msg:WebResponesContext=new WebResponesContext();
                    msg.ResponseMessage.Success=true;
                    msg.ResponseMessage.ErrorCode=0;
                    wx.invoke('navigateToAddCustomer', {

                    },function(res) {
                      console.log(res,"返回的参数zora");
                       msg.ResponseMessage.Success=true;
                          msg.ResponseMessage.ErrorMessage=res.errMsg;
                          resolve(msg);
                     });
                  });
               }
}

